import { Link } from "react-router-dom";
import { usePageContent } from "@/hooks/usePageContent";

const challenges = [
  {
    icon: "ri-time-line",
    title: "Property Not Selling",
    desc: "AI repositions the asset, re-prices it against live comparables and targets matched buyer pools.",
    image: "https://readdy.ai/api/search-image?query=A%20residential%20property%20with%20a%20prominent%20For%20Sale%20sign%20board%20in%20the%20front%20yard%2C%20slightly%20overgrown%20garden%20suggesting%20prolonged%20market%20listing%2C%20warm%20golden%20afternoon%20sunlight%2C%20suburban%20Indian%20neighborhood%20setting%2C%20professional%20real%20estate%20photography%20style%2C%20natural%20earthy%20warm%20tones%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&seq=challenge-not-selling-01&orientation=landscape",
  },
  {
    icon: "ri-building-2-line",
    title: "Vacant Land",
    desc: "Highest-and-best-use engine ranks 12 development uses by ROI, demand and approval risk.",
    image: "https://readdy.ai/api/search-image?query=An%20empty%20undeveloped%20plot%20of%20land%20covered%20with%20wild%20grass%20and%20scattered%20weeds%2C%20clearly%20unused%20and%20unproductive%2C%20surrounded%20by%20rural%20fencing%2C%20warm%20golden%20hour%20sunlight%20casting%20long%20shadows%2C%20Indian%20countryside%20setting%2C%20professional%20real%20estate%20photography%2C%20natural%20earthy%20tones%2C%20high%20detail%20texture%20on%20vegetation%20and%20soil&width=800&height=600&seq=challenge-vacant-land-02&orientation=landscape",
  },
  {
    icon: "ri-money-rupee-circle-line",
    title: "Need Joint Venture",
    desc: "Structured JV modelling with revenue-share scenarios and vetted developer matching.",
    image: "https://readdy.ai/api/search-image?query=Two%20business%20partners%20reviewing%20large%20architectural%20development%20blueprints%20spread%20across%20a%20modern%20conference%20table%2C%20construction%20site%20visible%20through%20floor-to-ceiling%20windows%2C%20warm%20natural%20afternoon%20light%2C%20professional%20corporate%20partnership%20atmosphere%2C%20photorealistic%20editorial%20photography%2C%20clean%20premium%20aesthetic%2C%20high%20detail&width=800&height=600&seq=challenge-joint-venture-03&orientation=landscape",
  },
  {
    icon: "ri-store-line",
    title: "Need Rental Income",
    desc: "Lease strategy with tenant-mix optimisation and rent benchmarking per micro-market.",
    image: "https://readdy.ai/api/search-image?query=A%20row%20of%20modern%20commercial%20shop%20fronts%20and%20rental%20units%20along%20a%20busy%20street%20with%20For%20Lease%20signage%20visible%2C%20clean%20well-maintained%20facades%2C%20warm%20golden%20afternoon%20light%2C%20urban%20Indian%20commercial%20district%2C%20professional%20real%20estate%20photography%2C%20architectural%20detail%2C%20inviting%20commercial%20atmosphere%2C%20clean%20composition&width=800&height=600&seq=challenge-rental-income-04&orientation=landscape",
  },
  {
    icon: "ri-leaf-line",
    title: "Need Property Valuation",
    desc: "Data-backed valuation blending transactions, circle rates, yield and development potential.",
    image: "https://readdy.ai/api/search-image?query=A%20professional%20property%20surveyor%20with%20modern%20equipment%20and%20measuring%20tools%20standing%20on%20an%20open%20plot%20of%20land%2C%20laptop%20with%20valuation%20data%20visible%2C%20warm%20natural%20sunlight%2C%20Indian%20urban%20fringe%20development%20area%2C%20professional%20real%20estate%20appraisal%20photography%2C%20clean%20documentary%20style%2C%20natural%20warm%20tones%2C%20high%20detail&width=800&height=600&seq=challenge-valuation-05&orientation=landscape",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Legal Issues",
    desc: "Title, encumbrance and conversion review with a remediation roadmap from legal partners.",
    image: "https://readdy.ai/api/search-image?query=Official%20land%20title%20deeds%20and%20property%20ownership%20documents%20spread%20neatly%20on%20a%20polished%20wooden%20desk%20with%20a%20brass%20seal%20stamp%20and%20fountain%20pen%2C%20warm%20desk%20lamp%20illumination%2C%20professional%20legal%20office%20atmosphere%2C%20rich%20warm%20brown%20tones%2C%20photorealistic%20still%20life%20photography%2C%20shallow%20depth%20of%20field%2C%20authoritative%20legal%20documents%20aesthetic&width=800&height=600&seq=challenge-legal-06&orientation=landscape",
  },
  {
    icon: "ri-scales-line",
    title: "Property Management",
    desc: "End-to-end asset management: tenants, collections, compliance and maintenance reporting.",
    image: "https://readdy.ai/api/search-image?query=A%20well-maintained%20modern%20residential%20apartment%20complex%20with%20clean%20landscaped%20gardens%2C%20professional%20property%20management%20signage%2C%20bright%20morning%20sunlight%2C%20organized%20tidy%20environment%2C%20professional%20real%20estate%20photography%2C%20warm%20natural%20tones%2C%20clean%20architectural%20composition%2C%20inviting%20residential%20atmosphere&width=800&height=600&seq=challenge-management-07&orientation=landscape",
  },
  {
    icon: "ri-settings-4-line",
    title: "Redevelopment",
    desc: "FSI potential, society economics and developer bid management with owner-uplift modelling.",
    image: "https://readdy.ai/api/search-image?query=Construction%20cranes%20and%20scaffolding%20surrounding%20an%20old%20building%20undergoing%20major%20redevelopment%20and%20renovation%2C%20modern%20steel%20framework%20rising%20beside%20heritage%20structure%2C%20warm%20golden%20sunset%20light%2C%20Indian%20urban%20development%20site%2C%20professional%20architectural%20construction%20photography%2C%20dynamic%20progress%20atmosphere%2C%20warm%20industrial%20tones%2C%20high%20detail&width=800&height=600&seq=challenge-redevelopment-08&orientation=landscape",
  },
];

export default function ChallengesSection() {
  const { getContent } = usePageContent('homepage');
  const heading = getContent('home-challenges-heading') || 'What Challenge Are You Facing?';

  return (
    <section id="challenges" className="py-24 bg-background-50">
      <div className="container mx-auto px-4 lg:px-8 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sm text-primary-500 font-medium uppercase tracking-wider mb-3">
            Owner Problems
          </span>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-950 mb-4">
            {heading}
          </h2>
          <p className="text-foreground-600">
            Every problem has a modelled AI solution and a clear next step.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {challenges.map((c) => (
            <div
              key={c.title}
              className="flex h-full flex-col rounded-2xl card-dark group hover:border-primary-500/40 transition-all duration-300 overflow-hidden"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={c.image}
                  alt={c.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="w-11 h-11 flex items-center justify-center rounded-2xl bg-primary-500/10 shrink-0 mb-5">
                  <i className={`${c.icon} text-xl text-primary-500`} />
                </div>
                <h3 className="font-display font-semibold text-lg text-foreground-950 mb-2">
                  {c.title}
                </h3>
                <div className="h-px w-full bg-foreground-200/30 my-4" />
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {c.desc}
                </p>
                <Link
                  to="/submit-property"
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:gap-2.5 transition-all"
                >
                  Get AI Solution
                  <i className="ri-arrow-right-line text-sm" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}